import { SUBTITLES_BACKGROUND as SUBTITLES_BACKGROUND_ENUM } from "../enums";
import { SelectedAudioTrack, SelectedVideoTrack } from "../types/common";
import { Subtitles } from "../types/player-api";

export enum PersistedStateName {
  MUTED = "muted",
  USER_PREFERED_AUDIO_TRACK = "userPreferredAudioTrack",
  USER_PREFERRED_SUBTITLES = "userPreferredSubtitles",
  USER_PREFERRED_VIDEO_TRACK = "selectedVideoTrack",
  VOLUME = "volume",
  SUBTITLES_BACKGROUND = "subtitlesBackground",
  SUBTITLES_SIZE = "subtitlesSizeMultiplier"
}

export type PersistedState = {
  [PersistedStateName.MUTED]?: boolean;
  [PersistedStateName.USER_PREFERED_AUDIO_TRACK]?: SelectedAudioTrack;
  [PersistedStateName.USER_PREFERRED_SUBTITLES]?: Subtitles;
  [PersistedStateName.USER_PREFERRED_VIDEO_TRACK]?: SelectedVideoTrack;
  [PersistedStateName.VOLUME]?: number;
  [PersistedStateName.SUBTITLES_BACKGROUND]?: SUBTITLES_BACKGROUND_ENUM;
  [PersistedStateName.SUBTITLES_SIZE]?: number;
};

export const storageKey = "PlayerUI:settings";
export const version = 1;

export const saveToStorage = <T extends PersistedStateName>(
  key: T,
  value: PersistedState[T]
) => {
  let playerUISettings;
  try {
    playerUISettings = JSON.parse(localStorage.getItem(storageKey) || "{}");
  } catch (_) {
    playerUISettings = {};
  }

  playerUISettings[key] = value;
  playerUISettings.$version = version;

  try {
    localStorage.setItem(storageKey, JSON.stringify(playerUISettings));
  } catch (_) {
    // ignore
  }
};

export const getAllFromStorage = (): PersistedState => {
  try {
    const values = localStorage.getItem(storageKey);

    return JSON.parse(values || "{}");
  } catch (_) {
    return {};
  }
};
